import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { GlobalContext } from '../../GlobalContext';
import Loading from '../loading/Loading';
import { isAuthenticated as checkAuth, getReturnUrl } from '../../utils/auth';

const PublicRoute = ({ children }) => {
  const { userData, isLoading, apiError } = useContext(GlobalContext);
  const location = useLocation();
  const [authStatus, setAuthStatus] = useState(null);

  useEffect(() => {
    // Clear logout flag if we're on the login page
    if (location.pathname === '/login') {
      sessionStorage.removeItem('dbsb_logout_in_progress');
    }

    const authResult = checkAuth(userData, isLoading, apiError);
    setAuthStatus(authResult);
  }, [userData, isLoading, apiError, location.pathname]);

  // Show loading while determining authentication status
  if (authStatus === null) {
    return <Loading />;
  }

  // If authenticated, redirect to dashboard or return URL
  if (authStatus) {
    const returnUrl = getReturnUrl(location.search);
    
    if (returnUrl) {
      return <Navigate to={returnUrl} replace />;
    }
    
    // Default redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, render the public component
  return children;
};

export default PublicRoute;
